<template>
    <rkm-layout-body title="Lista de fornecedor">
        <template v-slot:actions>
            <rkm-button
                @click="openCadastroFornecedorConectaSus"
                authorize="store-cadastro-fornecedor"
                color="primary"
            >
                Cadastrar fornecedor (ConectaSUS)
            </rkm-button>

            <rkm-button
                @click="$router.push({name: 'web-service-almoxarifado-cliente-fornecedor-create'})"
                authorize="store-web-service-almoxarifado-cliente-fornecedor"
                color="primary"
            >
                Cadastrar fornecedor
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/web-service/almoxarifado/cliente/fornecedor/List'

export default {
    components: {List},
    methods: {
        openCadastroFornecedorConectaSus() {
            window.open(this.$router.resolve({name: 'cadastro-fornecedor-create'}).href, '_blank')
        },
    },
}
</script>